import { RefObject } from 'react';
export interface IData {
    [key: string]: any;
}

export type IRender = (td: IData, rowIndex?: number, index?: number) => JSX.Element | number | string;

export enum TextAlign {
    revert = 'revert',
    unset = 'unset',
    left = 'left',
    center = 'center',
    end = 'end',
    justify = 'justify',
    right = 'right',
}

export enum FixedDirection {
    left = 'left',
    right = 'right',
    auto = '',
}

export interface IStyle {
    width?: string;
    textAlign?: TextAlign;
    left?: string;
    right?: string;
}

export interface ICalculatedColumn extends IColumn {
    position?: number;
}

export enum ScrollProcess {
    start = 'start',
    process = 'process',
    end = 'end',
}

export interface IColumn {
    key?: string;
    dataIndex: string; // data 索引，支持 'a.b.c' 的形式支持多层级数据
    name: string | JSX.Element; // th
    title?: string; // 鼠标 hover title，未设置则取 name
    width?: number | string; // 100px、10%、'auto'
    fixed?: FixedDirection; // 当前列是否固定悬浮, 须配合 width 使用(必须为具体值)
    textAlign?: TextAlign;
    className?: string;
    render?: IRender; // 自定义渲染 td
    children?: IColumn[];
}

export interface TheadRowItem {
    column: IColumn;
    colSpan?: number;
    rowSpan?: number;
    hasSubColumns?: boolean;
    colStart?: number;
    colEnd?: number;
    childrenCount?: number;
}

/**
 * 可以扩展react-virtualized的参数
 * 目前的以使用为主，原则是：保持简单，用到再加，不做未来设计。
 */
export interface IVirtualizedListProps {
    /**
     * Width of Grid; this property determines the number of visible (vs virtualized) columns.
     */
    width: number;
    height: number;
}

export interface IProps {
    className?: string;
    width?: number; // table 宽度，默认 100%，超过容器自动滚动
    data: IData[];
    isMultilevel?: boolean;
    refTable?: RefObject<HTMLDivElement>;
    scrollNumber?: number;
    columns: IColumn[];
    miniNumTdWidth?: number;
    onColumnClick?: (item: IData, dataIndex?: string) => void;
    blankListText?: string;
    blank?: string | JSX.Element; // 为空时的占位
    children?: string | JSX.Element; // 为空时的占位
    rowSelection?: IRowSelection;
    isTransformPx2Rem?: boolean;
    isVirtualized?: boolean; // 是否使用虚拟列表形式
    virtualizedListProps?: IVirtualizedListProps;
}

export enum ISelectMethods {
    ALL = 'all',
    MULTIPLE = 'multiple',
}

export interface ISelectionInfo {
    type: ISelectMethods;
}

export interface IRowSelection {
    columnWidth?: string | number;
    columnTitle?: string | React.ReactNode | (() => React.ReactNode);
    customizeRenderCell?: (record: IData, _rowIndex?: number, _index?: number) => JSX.Element;
    onSelectAll?: (selected: boolean, allKeys: string[], changeKeys: string[], changeRows: IData[]) => void;
    onSelectionChange?: (selectedRowKeys: string[], selectedRows: IData[], info: ISelectionInfo) => void;
    preserveSelectedRowKeys?: string[];
    key: string;
}

export interface IConfig {
    columns: IColumn[];
    data: IData[];
}

export type FlatColumnsFirstLevel = { [key: string]: IColumn[] };
